<template>
  <page :title="$tc('undisIncome')">
    <div class="box">
      <b-field>
        <p class="control">
          <b-dropdown ref="filterDropdown">
            <button class="button" slot="trigger">
              <span>{{ $tc('dropdown.filters')}}</span>
              <b-icon icon="menu-down"></b-icon>
            </button>

        <div class="dropdown-item" style="width: 300px;">
          <p class="title is-5">{{ $tc('undisIncome')+' '+$tc('dropdown.filters') }}</p>

          <b-field :label="$tc('dater.end')">
            <datepicker v-model="untilDate"></datepicker>
          </b-field>

          <button class="button is-primary" @click="filter">{{$tc('dropdown.filters')}}</button>

          <button class="button is-white" @click="$refs.filterDropdown.toggle()">{{ $tc('cancel') }}</button>
        </div>
        </b-dropdown>
        </p>

        <b-input icon="magnify" v-model="search" type="search" placeholder="Publisher" expanded></b-input>
      </b-field>

      <span class="tag">Until: {{ untilDate }}</span>

      <hr />
      <b-table
        class="is-middle"
        :data="filteredIncomes"
        :loading="incomes.loading"
        :default-sort="['distribute_amount', 'desc']"
      >
        <template slot-scope="props">
          <b-table-column label="Publisher" field="publisher_name">
            <router-link
              :to="'/publishers/' + props.row.publisher_id"
              v-if="props.row.publisher"
            >{{ props.row.publisher.name }}</router-link>
          </b-table-column>

          <b-table-column
            label="First"
            field="since"
            class="has-text-grey"
            centered
          >{{ props.row.since | date}}</b-table-column>

          <b-table-column
            label="Last"
            field="until"
            class="has-text-grey"
            centered
          >{{ props.row.until | date }}</b-table-column>

          <b-table-column
            label="Age (day)"
            field="diff_in_days"
            class="has-text-grey"
            centered
            sortable
          >{{ props.row.diff_in_days }}</b-table-column>

          <b-table-column
            label="Selling"
            field="sales_count"
            centered
            sortable
          >{{ props.row.sales_count }}</b-table-column>

          <b-table-column
            label="Income"
            field="publisher_income"
            class="has-text-centered"
            centered
            sortable
          >{{ props.row.publisher_income | money }}</b-table-column>

          <b-table-column
            label="Fee (Wplus and Qpay)"
            field="publisher_income_tax"
            class="has-text-centered"
            centered
            sortable
          >{{ props.row.publisher_income_tax | money }}</b-table-column>

          <b-table-column
            label="Distribute Amount"
            field="distribute_amount"
            class="has-text-centered"
            centered
            sortable
          >{{ props.row.distribute_amount | money }}</b-table-column>

          <b-table-column custom-key="actions" class="has-text-right" centered>
            <modal-opener
              :component="
                require('./../../../components/CreateDistributionModal').default
              "
              :props="{
                publisher: props.row.publisher,
                startDate: props.row.since,
                endDate: untilDate,
                dontRedirect: true,
                whenCreated: distribution =>
                  whenDistributionCreated(distribution, props.row)
              }"
            >
              <button class="button has-text-grey is-small" slot="trigger">distribute</button>
            </modal-opener>
          </b-table-column>
        </template>

        <template v-if="incomes.data.length > 0" slot="footer">
          <th colspan="4" class="has-text-weight-bold">Нийт: {{ incomes.data.length }}</th>

          <th class="has-text-centered">
            <strong v-if="incomes.response">
              {{
                incomes.response.data.total_sales_count
              }}
            </strong>
          </th>

          <th class="has-text-centered">
            <strong v-if="incomes.response">
              {{
                incomes.response.data.total_publisher_income | money
              }}
            </strong>
          </th>

          <th class="has-text-centered">
            <strong v-if="incomes.response">
              {{
                incomes.response.data.total_publisher_income_tax | money
              }}
            </strong>
          </th>

          <th class="has-text-centered">
            <strong v-if="incomes.response">
              {{
                incomes.response.data.total_distribute_amount | money
              }}
            </strong>
          </th>

          <th></th>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>No result.</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
import moment from "moment";

export default {
  data() {
    let date = this.yesterday();
    let search = null;

    return {
      untilDate: date,

      incomes: new window.RemoteCollection(
        "/api/publisher-income/undistributed"
      )
        .with({ until: date, exclude: "distributing" , search: search })
        .transform(income => {
          income.diff_in_days = moment().diff(moment(income.since), "days");
        })
        .load(),

      search: ""
    };
  },

  filters: {
    date(value) {
      return moment(value).format("YYYY-MM-DD");
    }
  },

  computed: {
    filteredIncomes() {
      return this.incomes.data.filter(income => {
        return (
          this.search === "" ||
          income.publisher.name
            .toUpperCase()
            .includes(this.search.toUpperCase())
        );
      });
    }
  },

  methods: {
    yesterday() {
      return moment()
        .subtract(1, "day")
        .format("YYYY-MM-DD");
    },

    whenDistributionCreated(distribution, income) {
      this.$buefy.toast.open("Moved to checking");

      let index = this.incomes.data.indexOf(income);

      this.incomes.data.splice(index, 1);
    },

    filter() {
      this.incomes.with({ until: this.untilDate }).load();
      this.$refs.filterDropdown.toggle();
    }
  }
};
</script>
